import React, { useContext } from 'react';
import { ThemeProvider } from '../Contexts/ThemeContext';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { DataDisplayProvider, PendoInitializer, SidebarNavProvider } from '@aidkitorg/component-library';
import { PaymentsPage } from './Payments/PaymentsPage';
import { PaymentBatchDetailsPage } from './Payments/PaymentBatchDetailsPage';
import { PaymentsProvider } from '../Contexts/PaymentsContext';
import { AdminPanelPage } from './AdminPanelPage';
import { AccountsPage } from './Accounts/AccountsPage';
import { get_deployment } from '../API';
import { PublicConfigurationContext, UserInfoContext } from '../Context';
import { AccountsProvider } from '../Contexts/AccountsContext';
import { DashboardsPage } from './Dashboards/DashboardsPage';
import { DashboardBuilderPage } from './Dashboards/DashboardBuilderPage';
import { useLocalizedStrings } from '../Localization';
import { DashboardsProvider } from '../Contexts/DashboardsContext';
import { DashboardPage } from './Dashboards/DashboardPage';
import { SettingsProvider } from '../Contexts/SettingsContext';
import { SettingsPage } from './Settings/SettingsPage';
import { ManageFieldsPage } from './Settings/ManageFieldsPage';
import { ReportsPage } from './Reports/ReportsPage';
import { ReportsBuilderPage } from './Reports/ReportsBuilderPage';
import { ReportViewPage } from './Reports/ReportViewPage';
import { ReportsProvider } from '../Contexts/ReportsContext';
import { NotificationsPage } from './Notifications/NotificationsPage';
import { NotificationRecipientsPage } from './Notifications/NotificationRecipientsPage';
import { NotificationsProvider } from '../Contexts/NotificationsContext';

// TODO: use AppShell to build out an OverviewPage -- this is just temporary to test out the ThemeProvider
const OverviewPage = () => {
  const L = useLocalizedStrings()
  
  return (
    <AdminPanelPage 
      title={L.admin_panel.nav.dashboard_home}
      breadcrumbs={[
        {
          label: L.admin_panel.nav.home
        }
      ]}
    >
      <></>
    </AdminPanelPage>
  )
}

export const AdminPanelApp = () => {
  let { path } = useRouteMatch();
  const publicConfig = useContext(PublicConfigurationContext);
  const userInfo = useContext(UserInfoContext);
  const programName = get_deployment();

  return (
    <ThemeProvider>
      <DataDisplayProvider value={{ displayInUTC: false }}>
        <SidebarNavProvider>
          {
            publicConfig.experimental?.enablePendo && (
              <PendoInitializer visitorData={{
                id: userInfo.uid || "unknown"
              }} accountData={{
                id: programName || "unknown"
              }} />)
          }
          <Switch>
            <Route path={`${path}/overview`} component={OverviewPage} />

            {/* PAYMENTS ROUTES */}
            <Route 
              exact
              path={`${path}/payments`} 
              children={ 
                <PaymentsProvider>
                  <PaymentsPage/>
                </PaymentsProvider>
              } 
            />
            <Route 
              path={`${path}/payments/payment-details/:batch_name`}
              children={
                <PaymentsProvider>
                  <PaymentBatchDetailsPage/>
                </PaymentsProvider>
              }
            />

            {/* ACCOUNTS ROUTES */}
            <Route
              path={`${path}/accounts`}
              children={
                <AccountsProvider>
                  <AccountsPage/>
                </AccountsProvider>
              }
            />

            {/* DASHBOARDS ROUTES */}
            <Route 
              exact
              path={`${path}/dashboards`}
              children={
                <DashboardsProvider>
                  <DashboardsPage/>
                </DashboardsProvider>
              }
            />
            <Route
              exact
              path={`${path}/dashboards/new`}
              children={
                <DashboardsProvider>
                  <SettingsProvider>
                    <DashboardBuilderPage/>
                  </SettingsProvider>
                </DashboardsProvider>
              }
            />
            <Route
              path={`${path}/dashboards/:dashboardId/edit`}
              children={
                <DashboardsProvider>
                  <SettingsProvider>
                    <DashboardBuilderPage/>
                  </SettingsProvider>
                </DashboardsProvider>
              }
            />
            <Route
              path={`${path}/dashboards/:dashboard_id`}
              children={
                <DashboardsProvider>
                  <DashboardPage/>
                </DashboardsProvider>
              }
            />

            {/* REPORTS ROUTES */}
            <Route
              exact
              path={`${path}/reports`}
              render={() => (
                <ReportsProvider>
                  <ReportsPage />
                </ReportsProvider>
              )}
            />
            <Route
              exact
              path={`${path}/reports/new`}
              render={() => (
                <ReportsProvider>
                  <SettingsProvider>
                    <ReportsBuilderPage />
                  </SettingsProvider>
                </ReportsProvider>
              )}
            />
            <Route
              exact
              path={`${path}/reports/:reportId/edit`}
              render={(routeProps) => (
                <ReportsProvider key={routeProps.match.params.reportId}>
                  <SettingsProvider>
                    <ReportsBuilderPage />
                  </SettingsProvider>
                </ReportsProvider>
              )}
            />
            <Route
              path={`${path}/reports/:reportId`}
              render={(routeProps) => (
                <ReportsProvider key={routeProps.match.params.reportId}>
                  <ReportViewPage />
                </ReportsProvider>
              )}
            />

            {/* SETTINGS ROUTES */}
            <Route 
              exact
              path={`${path}/settings`}
              render={() => (
                <SettingsProvider>
                  <SettingsPage />
                </SettingsProvider>
              )}
            />
            <Route 
              exact
              path={`${path}/settings/manageFields`}
              render={() => (
                <SettingsProvider>
                  <ManageFieldsPage />
                </SettingsProvider>
              )}
            />

            {/* NOTIFICATIONS ROUTES */}
            <Route
              exact
              path={`${path}/notifications`}
              children={
                <NotificationsProvider>
                  <NotificationsPage/>
                </NotificationsProvider>
              }
            />
            <Route
              path={`${path}/notifications/notification-details/:targetFieldPrefix`}
              children={
                <NotificationsProvider>
                  <NotificationRecipientsPage/>
                </NotificationsProvider>
              }
            />
            
            <Route path={`${path}`} component={OverviewPage} />
            {/* Add 404 */}
          </Switch>
        </SidebarNavProvider>
      </DataDisplayProvider>
    </ThemeProvider>      
  )
}

export default AdminPanelApp;